import orderReviews from './en-US/orderReviews';

export default {
  ...orderReviews,
};
